const user = {
  state: {
    // 个人中心批量充值卡号
    iccids:[],
    // h5充值的参数
    rechargeData:{}
  },

  mutations: {
    iccidsMethod:(state,iccids) =>{
        state.iccids = iccids;
    },
    rechargeMethod:(state,rechargeData) =>{
        state.rechargeData = rechargeData;
    }
  },

}

export default user
